module.exports = __webpack_public_path__ + "545177ee49a7eccc976911b4cae3291f.gif";